import { apiInstance } from '@diamond/shared/utils';

export type ProductLimitationConfigurationType =
  | 'GLOBAL_DISTRIBUTION_CHANNEL'
  | 'EXCLUDE_SHIPTO'
  | 'SHIPTO';

interface ProductLimitationConfigurationMeta {
  importEndpoint: string;
  exportEndpoint: string;
  exportFilename: string;
}

export const PRODUCT_LIMITATION_CONFIGURATION_META: Record<
  ProductLimitationConfigurationType,
  ProductLimitationConfigurationMeta
> = {
  GLOBAL_DISTRIBUTION_CHANNEL: {
    importEndpoint:
      '/backoffice/master-data/product-manual-configurations/import',
    exportEndpoint:
      '/backoffice/master-data/product-manual-configurations/export',
    exportFilename: 'product_manual_configurations.xlsx',
  },
  EXCLUDE_SHIPTO: {
    importEndpoint:
      '/backoffice/master-data/product-manual-exclude-shipto-configurations/import',
    exportEndpoint:
      '/backoffice/master-data/product-manual-exclude-shipto-configurations/export',
    exportFilename: 'product_manual_exclude_shipto_configurations.xlsx',
  },
  SHIPTO: {
    importEndpoint:
      '/backoffice/master-data/product-manual-shipto-configurations/import',
    exportEndpoint:
      '/backoffice/master-data/product-manual-shipto-configurations/export',
    exportFilename: 'product_manual_shipto_configurations.xlsx',
  },
} as const;

const MULTIPART_FORM_HEADERS = {
  'Content-Type': 'multipart/form-data',
} as const;

export interface ProductLimitationImportResponse {
  success: boolean;
  message: string;
  data: {
    imported_count: number;
  };
}

export const importProductLimitation = async (
  token: string,
  file: File,
  configurationType: ProductLimitationConfigurationType = 'SHIPTO'
): Promise<ProductLimitationImportResponse> => {
  const formData = new FormData();
  formData.append('file', file, file.name);

  const endpoint =
    PRODUCT_LIMITATION_CONFIGURATION_META[configurationType].importEndpoint;

  const response = await apiInstance(token, {
    headers: MULTIPART_FORM_HEADERS,
  }).post<ProductLimitationImportResponse>(endpoint, formData);

  return response.data;
};

export const exportProductLimitation = async (
  token: string,
  configurationType: ProductLimitationConfigurationType = 'SHIPTO'
): Promise<Blob> => {
  const endpoint =
    PRODUCT_LIMITATION_CONFIGURATION_META[configurationType].exportEndpoint;

  const response = await apiInstance(token, {
    responseType: 'blob',
  }).get<Blob>(endpoint);

  return response.data;
};
